import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { UserProfileStore } from '@/store/store.userProfile';
import { UserProfile } from '@/models/dexie/UserProfile';
import { Configuration } from '@/models/configuration/Configuration';
import { ConfigurationSection } from '@/models/configuration/Section';

import { UnitsMenuItem } from '@/models/general/UnitsMenuItem';
import { ConfigurationService } from '@/services';

@Component
export default class UnitsMenuComponent extends Vue {
    @PropSync('show', { type: Boolean }) public syncedShow!: boolean;

    public userProfile?: UserProfile;
    public unitsConfiguration: Configuration = new Configuration();
    public units: ConfigurationSection[] = [];
    public selectedUnits: UnitsMenuItem[] = [];

    // tslint:disable-next-line: no-empty
    public mounted() {

        ConfigurationService.OnUnitsChanged.on((units) => {
            if (units) {
                this.unitsConfiguration = units;
                this.units = this.unitsConfiguration.sections;
                this.generateSelectItems();
            }
        });

        this.userProfile = this.getUserProfile;
        this.unitsConfiguration = this.getUnitsConfiguration;
        this.units = this.unitsConfiguration.sections;
        this.generateSelectItems();
    }

    public beforeDestroy() {
        ConfigurationService.OnUnitsChanged.off(() => null);
    }

    get getUserProfile(): UserProfile {
        return UserProfileStore.userProfile;
    }

    get getUnitsConfiguration() {
        return ConfigurationService.GetUnitsConfiguration;
    }

    @Watch('getUserProfile', { deep: false, immediate: false })
    public onGetIsLoggedInChanged(newValue: UserProfile) {
        this.userProfile = newValue;
        this.checkProfileSelection();
    }

    public onUnitChanged(unit: UnitsMenuItem) {
        UserProfileStore.ChangeProfileUnit(unit);
    }

    /**
     * Method to fetch translation with fallback
     * @param unit ConfigurationSection
     */
    public getIdentifierText(unit: ConfigurationSection): string {
        let ret: string = '';
        if (unit && unit.identifier) {
            ret = this.$vuetify.lang.t(`$vuetify.identifiers.${unit.identifier}`);
            if (ret.length === 0 || ret.includes('$vuetify.identifiers.')) {
                ret = unit.name;
            }
        }
        return ret;
    }

    private generateSelectItems() {
        this.selectedUnits.splice(0, this.selectedUnits.length);
        this.units.forEach((unit) => {
            this.selectedUnits.push(new UnitsMenuItem(unit));
        });
        this.checkProfileSelection();
    }

    private checkProfileSelection() {
        if (this.userProfile !== undefined) {
            this.selectedUnits.forEach((selectedUnit) => {
                const userUnit = this.userProfile && this.userProfile.units
                    && this.userProfile.units.find((unit) => unit.unitIdentifier === selectedUnit.identifier);
                if (userUnit) {
                    selectedUnit.selectedUnitFormat = userUnit.selectedValue;
                } else {
                    selectedUnit.selectedUnitFormat = selectedUnit.base || 0;
                }
            });
        }
    }
}
